import { getRewardChainById } from "@cede/utils";
import { arbitrum, base, mainnet, sepolia } from "viem/chains";

/**
 * Maps a reward chain ID to the InternalChainId network code understood by the
 * CDN/network helpers (`forgeNetworkURL`, `getNetworkName`). These are the codes
 * the rewards UI used before multichain (e.g. the hardcoded "arbitrumone").
 */
const REWARD_CHAIN_NETWORK_CODE: Record<number, string> = {
  [arbitrum.id]: "arbitrumone",
  [mainnet.id]: "ethereum",
  [base.id]: "base",
  [sepolia.id]: "sepolia",
};

/**
 * Network code for a reward chain, for use with `forgeNetworkURL` /
 * `getNetworkName`. Returns `undefined` for unknown chains — callers decide how
 * to render that (no silent fallback to a default network here).
 */
export function getRewardNetworkCode(chainId: number): string | undefined {
  return REWARD_CHAIN_NETWORK_CODE[chainId];
}

/**
 * Human-readable label for a reward chain (e.g. "Arbitrum One", "Ethereum").
 * Falls back to the chain ID string when the chain isn't a known reward chain,
 * so the UI never renders an empty heading.
 */
export function getRewardChainLabel(chainId: number): string {
  return getRewardChainById(chainId)?.name ?? `Chain ${chainId}`;
}
